<template>
  <el-dialog :visible.sync="isVisible" width="700px" class="notice-wrap" @close="handleClose" top="0">
    <div slot="title">
      <span class="title">【好分数辅导】关于“账户余额转课时”的通知</span>
    </div>
    <div class="notice-text">
        <div style="margin-bottom:10px;">
            为了保障广大学员的切身利益，确保学员学费与课时数据安全，好分数辅导慎重决定于<span>2019年6月1日</span>起全面实行课时制度。
            <span>届时学员的学费将以课时的形式体现，每上一节课扣除一个课时，且不再支持扣减余额的上课方式。</span>学员已充值账户余额将由系统转化为相应的课时数，此操作不影响学员正常上课或享受服务。详情请咨询您的学管师或规划师，或致电4008-180-190了解更多信息。
        </div>
      好分数辅导以“帮助每一个孩子成就最好的自己”为己任，一直致力于打造最高效的个性化1对1辅导教学服务，在教研、师资、学习平台研发和服务等方面精益求精力争行业第一，未来也将为每位学员提供更优质的学习体验。非常感谢您一直以来的支持！
      <div class="notice-footer" style="margin-top:10px;">好分数辅导</div>
      <div class="notice-footer">2019年5月</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
    props: {
        isShowNotice: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isVisible: this.isShowNotice
        };
    },
    beforeMount() {
    },
    watch: {
        isShowNotice(val) {
            this.isVisible = val;
        }
    },
    methods: {
        handleClose() {
            this.$http.put('/v1/user-center/notify', { notifyType: 1 })
                .then(resp => this.$checkResp(resp))
                .then(() => {
                    this.$emit('update:isShowNotice', false);
                })
                .catch((err) => {
                    this.$handleError(err.msg);
                });
        }
    }

};
</script>

<style lang="sass" scoped>
.notice-wrap {
    margin-top: calc(50vh - 160px);

    /deep/ .el-dialog__body {
        padding: 0 30px 25px;
        background: url('https://ks3-cn-beijing.ksyun.com/slwimage/ODTools/notice_background.png') right bottom / 180px 260px no-repeat;
    }
}

.title {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #333;
}

.notice-text {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #6a6a6a;
    line-height: 26px;

    span {
        color: #151515;
        font-family: PingFangSC-Medium;
    }

    .notice-footer {
        text-align: right;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #000;
        line-height: 26px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/NoticeDialog.vue